import { ISeason } from "@/zodTypes";
import endpoints from "@/endpoints.json";

const getSeasonsLastEpisode = async (season: number) => {
  const res: ISeason = await fetch(`${endpoints.metadata}/s${season.toString().padStart(2, "0")}.json`).then((res) =>
    res.json()
  );

  return res.episodes.length;
};

export default getSeasonsLastEpisode;
